// extracted by mini-css-extract-plugin
export default {"container":"employeeCounts_container__QIdLE","text":"employeeCounts_text__MsfqO"};